module.exports = __webpack_public_path__ + "static/media/3.038a9494.png";